import { createContext } from 'react';
import type { Chat } from '@trinity/chat';

export type OpenFeedbackModalProps = {
  chatInstanceId: number;
  queryIdentifier: string;
  rating: Chat.Rating;
};

type OpenQueryFeedbackModalContextValue = (props: OpenFeedbackModalProps) => void;

export const OpenQueryFeedbackModalContext = createContext<OpenQueryFeedbackModalContextValue>(null);